var $ = jQuery.noConflict();

$(function(){

        
    if ($('.productView-buttons .productView-quantity').hasClass('minimum-quantity-product')) {

        // Define minProdQty from the data attribute
        let minProdQty = Number($('.productView-buttons span[data-min-prod-qty]').data('min-prod-qty'));
        //console.log("minProdQty: " + minProdQty);


        // Function to update the subtotal
        function updateSubtotalFDP() {
            // Select the input element and get the quantity and data-price
            var $quantityInput1 = $('.productView-group .form-input.quantity__input');
            var quantity1 = parseInt($quantityInput1.val());
            var price1 = parseInt($quantityInput1.data('price'));

            // Calculate the subtotal
           var subtotalUpdate1 = quantity1 * price1;

            // Format subtotal to include a decimal point before the last two digits
            subtotalUpdate1 = subtotalUpdate1.toString().replace(/(\d+)(\d{2})$/, '$1.$2');

            // Update the subtotal element with the formatted subtotal
            $('.productView-subtotal .money').text(`$${subtotalUpdate1}`);
        }

        // Event listener to call updateSubtotalFDP function when quantity changes
        $('.productView-group .form-input.quantity__input').on('input', updateSubtotalFDP);

        // Initial call to set subtotal on page load
        updateSubtotalFDP();



        if (minProdQty !== undefined) {  
            if (!isNaN(minProdQty)) {   
                if ($('.productView-group .form-input.quantity__input').length) { 
                
                    $('.productView-group #product-add-to-cart, .productView-stickyCart #product-sticky-add-to-cart').off('click').on('click', function() {
                        // Retrieve the current quantity input value
                        let quantityInputValue = Number($('.productView-group .form-input.quantity__input').val());
                        
                        console.log("minProdQty: " + minProdQty);
                        console.log("quantityInputValue: " + quantityInputValue);

                        // Check if quantity meets the minimum requirement
                        if (minProdQty >= quantityInputValue) {
                            //console.log('The quantity matches the minimum required quantity.');
                            
                            setTimeout(function() {
                                $('.productView-buttons span[data-min-prod-qty]').removeClass('minimum-not-met');
                                $('.productView-group .form-input.quantity__input').val('1').attr('min', 1);
                                $('.productView-stickyCart .quantity__input').val('1').attr('min', 1);

                                updateSubtotalFDP();

                            }, 1000);
                        }
                        else if (minProdQty < quantityInputValue) {
                            //console.log('The quantity matches the minimum required quantity.');
                            
                            setTimeout(function() {
                                $('.productView-buttons span[data-min-prod-qty]').removeClass('minimum-not-met');
                                $('.productView-group .form-input.quantity__input').val('1').attr('min', 1);
                                $('.productView-stickyCart .quantity__input').val('1').attr('min', 1);

                                updateSubtotalFDP();

                            }, 1000);
                        } else {
                            //console.log('The quantity does not meet the minimum required quantity.');
                        }
                    });

                    // Get the value of input[name="id"] in .productView-buttons
                    const productId = $('.productView-buttons .productView-buttons input[name="id"]').val();
                    //console.log("productId: " + productId);

                    // Listen for a click event on elements with data-cart-remove-id in .halo-cart-sidebar
                    $('.halo-cart-sidebar').off('click', '[data-cart-remove-id]').on('click', '[data-cart-remove-id]', function() {
                        const cartRemoveId = $(this).data('cart-remove-id');

                        // Check if cartRemoveId matches productId
                        if (cartRemoveId == productId) {
                            //console.log('The cart item being removed matches the product ID in .productView-buttons');
                            
                            $('.productView-buttons span[data-min-prod-qty]').addClass('minimum-not-met');
                            $('.productView-group .form-input.quantity__input').val(minProdQty).attr('min', minProdQty);
                            $('.productView-stickyCart .quantity__input').val(minProdQty).attr('min', minProdQty);

                            updateSubtotalFDP();

                        }
                    });
                } // quantity length
            } // isNaN
        }
    } // minimum-quantity-product





    function sg9ExpandProductSpecifications() {
        
        if ( $('body').hasClass('template-product') ) { 

            //var documentWidth = $(document).width();        
            var documentWidth = $(window).outerWidth();        
            //var documentWidth = $(window).width();        
            
            // Remove any existing click handlers to prevent stacking
            $('.product-specifications-title').off('click');
            
            // Handle visibility and click functionality based on width
            if (documentWidth > 550) {                
                $('#product-specifications').show();
                $('.product-specifications-title').attr('aria-expanded', true).addClass('expand');
            } else {
                // On mobile: if product-specifications-wrapper exists, auto-expand specs
                if ($('.product-specifications-wrapper').length) {
                    $('#product-specifications').show();
                    $('.product-specifications-title').attr('aria-expanded', true).addClass('expand');
                } else {
                    $('#product-specifications').hide();
                    $('.product-specifications-title').attr('aria-expanded', false).removeClass('expand');
                }
                
                // Only set up click handler for mobile view
                $('.product-specifications-title').on('click',function(){
                    if($(this).hasClass('expand')){
                        $(this).removeClass('expand');
                        $(this).next().slideUp();
                        $(this).find('.fa-minus').addClass('fa-plus').removeClass('fa-minus');
                        $(this).attr('aria-expanded', false);
                    } else {
                        $(this).addClass('expand');
                        $(this).next().slideDown();
                        $(this).find('.fa-plus').removeClass('fa-plus').addClass('fa-minus');
                        $(this).attr('aria-expanded', true);
                    }
                });
            }
        }

//console.log("documentWidth:" + documentWidth);

    } // sg9ExpandProductSpecifications()

    sg9ExpandProductSpecifications()



    
    // Run Scripts after Window Resize
	/*! run scirpt after resize by Dolan Antenucci https://stackoverflow.com/users/318870/dolan-antenucci-   - https://stackoverflow.com/posts/5926068/revisions https://stackoverflow.com/questions/5489946/jquery-how-to-wait-for-the-end-of-resize-event-and-only-then-perform-an-ac/5926068#5926068 */
	var rtime;
	var timeout = false;
	var delta = 100;
	$(window).resize(function() {
		rtime = new Date();
		if (timeout === false) {
			timeout = true;
			setTimeout(resizeend, delta);
		}
	});

	function resizeend() {

	   if (new Date() - rtime < delta) {
			setTimeout(resizeend, delta);
		} else {
			timeout = false;

                sg9ExpandProductSpecifications();     

		}

	} // resizeend()


    /* // Add inner div to swatches containers on product page
   
         $('.pl-swatches__group.pl-swatches__group--pills .pl-swatches__container').each(function(){
            $(this).wrapInner('<div class="swatches-wrapper"><div></div></div>');
            // Only add dropdown and arrow-icons class when there is more than one anchor element
            if ($(this).find('a').length > 1) {
                $(this).find('.swatches-wrapper').append('<span class="platmart-dropdown"><span></span></span>');
                $(this).find('.swatches-wrapper').addClass('arrow-icons');
            }
        });

        // Add inner div wrapping for color, image, and mixed swatch groups in productView-top
        /*
        $('.productView-top .pl-swatches .pl-swatches__group.pl-swatches__group--colors .pl-swatches__container, .productView-top .pl-swatches .pl-swatches__group.pl-swatches__group--images .pl-swatches__container, .productView-top .pl-swatches .pl-swatches__group.pl-swatches__group--mixed .pl-swatches__container').each(function(){
            $(this).wrapInner('<div></div>');
        });
   */

    // Toggle swatches expanded class on click
    /*
    $('.swatches-wrapper').on('click', 'a[href*="javascript:void(0)"]', function(){
        $(this).closest('.swatches-wrapper').toggleClass('swatches-expanded');        
        $(this).closest('.pl-swatches__container').toggleClass('swatches-expanded');
    }); */
   


/*
    // ==========================================
    // GLOBO WIDGET - Change Add to Cart button text
    // ==========================================
    if ($('body').hasClass('template-product')) {
        
        // Function to update Globo widget add to cart button text
        function updateGloboAddToCartText() {
            $('div[class*="globo_widget"] .ga-product_addtocart').each(function() {
                var $btn = $(this);
                // Only change if not already set to "+ Add"
                if ($btn.text().trim() !== '+ Add' && !$btn.hasClass('globo-btn-updated')) {
                    $btn.text('+ Add');
                    $btn.attr('data-add', '+ Add');
                    $btn.addClass('globo-btn-updated');
                }
            });
        }
        
        // Initial call for already loaded content
        updateGloboAddToCartText();
        
        // Set up MutationObserver for Globo widget changes
        var globoWidgets = document.querySelectorAll('div[class*="globo_widget"]');
        
        if (globoWidgets.length > 0 && typeof MutationObserver !== 'undefined') {
            var globoObserver = new MutationObserver(function(mutations) {
                // Debounce to avoid multiple rapid calls
                clearTimeout(window.globoObserverTimer);
                window.globoObserverTimer = setTimeout(function() {
                    console.log('[sg-product] Globo widget content changed -> updating button text');
                    updateGloboAddToCartText();
                }, 100);
            });
            
            // Observe each Globo widget
            globoWidgets.forEach(function(widget) {
                globoObserver.observe(widget, { 
                    childList: true, 
                    subtree: true 
                });
            });
            
            console.log('[sg-product] Globo widget observer initialized for', globoWidgets.length, 'widget(s)');
        }
        
        // Also run on window load in case Globo loads late
        $(window).on('load', function() {
            setTimeout(updateGloboAddToCartText, 500);
            setTimeout(updateGloboAddToCartText, 1500);
        });
    }*/


}) // document ready

// Listen for Judge.me's official initialization event on product pages
//if ($('body').hasClass('template-product')) {
    document.addEventListener('jdgm.doneSetup', function(event) {
        console.log('Judge.me reviews loaded - jdgm.doneSetup event fired');

        // Process Judge.me reviews - clone images and hide originals
        processJudgeMeReviews();
        
    // Function to process reviews - can be called multiple times safely
    function processJudgeMeReviews() {
        $('.jdgm-rev').each(function() {
            const $review = $(this);
            const $media = $review.find('.jdgm-rev__media');
            const $header = $review.find('.jdgm-rev__header');
            
            // First, hide the media container with inline style (more reliable)
            if ($media.length > 0 && !$media.hasClass('sg-processed')) {
                $media.attr('style', 'display: none !important');
                $media.addClass('sg-processed');
            }
            
            // Check if cloned image already exists as DIRECT child of review (not inside media)
            const $existingClone = $review.children('.cloned-review-image');
            if ($existingClone.length > 0) {
                return; // Already processed correctly
            }
            
            // Remove any misplaced cloned images (inside media container)
            $review.find('.jdgm-rev__media .cloned-review-image').remove();
            
            // Find the first pic link in media container
            const $firstPicLink = $media.find('a.jdgm-rev__pic-link').first();
            
            if ($firstPicLink.length > 0 && $header.length > 0) {
                // Clone the first picture link
                const $clonedPicLink = $firstPicLink.clone();
                $clonedPicLink.addClass('cloned-review-image');
                $clonedPicLink.removeClass('jdgm--loading');
                
                // Change the image URL to higher resolution and ensure src is set
                $clonedPicLink.find('img').each(function() {
                    const $img = $(this);
                    const currentSrc = $img.attr('src');
                    const currentDataSrc = $img.attr('data-src');
                    
                    // Determine the best source URL (prefer data-src for lazy loaded images)
                    let imageUrl = currentDataSrc || currentSrc;
                    
                    if (imageUrl) {
                        // Update to higher resolution
                        imageUrl = imageUrl.replace('w=160', 'w=600');
                        
                        // Always set both src and data-src to ensure image loads
                        $img.attr('src', imageUrl);
                        $img.attr('data-src', imageUrl);
                        
                        // Remove lazy loading class if present
                        $img.removeClass('lazyload lazy');
                    }
                });
                
                // Insert BEFORE the header (as first child of review after any existing clones)
                $header.before($clonedPicLink);
            }
        });
    }

        // Extract the rating value and place it in the summary inner
        const $summary = $('#judgeme_product_reviews .jdgm-rev-widg__summary');
        if ($summary.length > 0) {
            const summaryText = $summary.text().trim();
            const ratingMatch = summaryText.match(/^(\d+\.?\d*)/);
            if (ratingMatch) {
                const rating = ratingMatch[1];
                const $summaryInner = $summary.closest('.jdgm-rev-widg').find('.jdgm-rev-widg__summary-inner');
                if ($summaryInner.length > 0 && !$summaryInner.find('.rating-value').length) {
                    $summaryInner.prepend(`<span class="rating-value">${rating}</span>`);
                }
            }
        }

        // Function to fix carousel width issues after our DOM modifications
        function applyJudgeMeCarouselSettings() {
            const $carousel = $('.jdgm-row-carousel');
            
            if ($carousel.length === 0) {
                return;
            }
            
            // Check if carousel has broken widths
            const $track = $carousel.find('.jdgm-glider-track');
            const $slides = $carousel.find('.jdgm-glider-slide');
            
            if ($track.length === 0 || $slides.length === 0) {
                return;
            }
            
            // Get current widths
            const trackWidth = parseInt($track.css('width')) || 0;
            const slideWidth = parseInt($slides.first().css('width')) || 0;
            
            // Check for NaN class or zero widths
            const hasNaN = $slides.first().attr('class') && $slides.first().attr('class').indexOf('NaN') !== -1;
            const isBroken = (trackWidth === 0 || slideWidth === 0 || hasNaN);
            
            if (isBroken) {
                console.log('Judge.me carousel widths broken - attempting fix (track:' + trackWidth + ', slide:' + slideWidth + ', NaN:' + hasNaN + ')');
                
                // Try to trigger Glider refresh via window resize
                $(window).trigger('resize');
                window.dispatchEvent(new Event('resize'));
                
                // Also try to access Glider instance directly
                const gliderEl = $carousel.find('.jdgm-glider')[0];
                if (gliderEl && gliderEl._glider) {
                    gliderEl._glider.refresh(true);
                    console.log('Judge.me Glider refreshed directly');
                }
            }
            
            // Always apply drag bounds constraints (even if widths are not broken)
            applyJudgeMeCarouselDragBoundsLocal();
        }
        
        // Local function to constrain carousel drag bounds (within jdgm.doneSetup scope)
        function applyJudgeMeCarouselDragBoundsLocal() {
            const $carousel = $('.jdgm-row-carousel');
            
            if ($carousel.length === 0) {
                return;
            }
            
            $carousel.each(function() {
                const $thisCarousel = $(this);
                const $gliderContainer = $thisCarousel.find('.jdgm-glider');
                const gliderEl = $gliderContainer[0];
                
                // Skip if already processed
                if ($thisCarousel.hasClass('sg-drag-bounds-applied')) {
                    return;
                }
                
                $thisCarousel.addClass('sg-drag-bounds-applied');
                
                // Function to check and correct scroll position
                function constrainScrollPosition() {
                    if (!gliderEl || !gliderEl._glider) {
                        return;
                    }
                    
                    const glider = gliderEl._glider;
                    const $track = $(gliderEl).find('.jdgm-glider-track');
                    const $slides = $(gliderEl).find('.jdgm-glider-slide');
                    
                    if ($track.length === 0 || $slides.length === 0) {
                        return;
                    }
                    
                    const containerWidth = $(gliderEl).width();
                    const trackWidth = $track[0].scrollWidth || parseInt($track.css('width')) || 0;
                    const slideCount = $slides.length;
                    
                    if (containerWidth <= 0 || trackWidth <= 0 || slideCount <= 0) {
                        return;
                    }
                    
                    // Calculate maximum scroll position (track width minus container width)
                    const maxScroll = Math.max(0, trackWidth - containerWidth);
                    const currentScroll = gliderEl.scrollLeft || 0;
                    
                    // Constrain scroll position within bounds
                    if (currentScroll < 0) {
                        gliderEl.scrollLeft = 0;
                        console.log('Judge.me carousel: corrected over-scroll to left');
                    } else if (currentScroll > maxScroll) {
                        gliderEl.scrollLeft = maxScroll;
                        console.log('Judge.me carousel: corrected over-scroll to right');
                    }
                }
                
                // Function to snap to nearest slide after drag ends
                function snapToNearestSlide() {
                    if (!gliderEl || !gliderEl._glider) {
                        return;
                    }
                    
                    const glider = gliderEl._glider;
                    const currentScroll = gliderEl.scrollLeft || 0;
                    const $slides = $(gliderEl).find('.jdgm-glider-slide');
                    
                    if ($slides.length === 0) {
                        return;
                    }
                    
                    const slideWidth = $slides.first().outerWidth(true) || 0;
                    
                    if (slideWidth <= 0) {
                        return;
                    }
                    
                    // Calculate nearest slide index
                    const nearestSlideIndex = Math.round(currentScroll / slideWidth);
                    const maxSlideIndex = Math.max(0, $slides.length - Math.floor($(gliderEl).width() / slideWidth));
                    const constrainedIndex = Math.max(0, Math.min(nearestSlideIndex, maxSlideIndex));
                    
                    // Scroll to the nearest valid slide
                    if (glider.scrollItem) {
                        glider.scrollItem(constrainedIndex, false);
                    }
                }
                
                // Listen for scroll events to constrain position
                $gliderContainer.off('scroll.sgBounds').on('scroll.sgBounds', function() {
                    // Use requestAnimationFrame for smooth constraint checking
                    if (window.sgCarouselScrollRAF) {
                        cancelAnimationFrame(window.sgCarouselScrollRAF);
                    }
                    window.sgCarouselScrollRAF = requestAnimationFrame(constrainScrollPosition);
                });
                
                // Listen for drag/touch end to snap to valid position
                $gliderContainer.off('mouseup.sgBounds touchend.sgBounds').on('mouseup.sgBounds touchend.sgBounds', function() {
                    // Small delay to let the momentum scrolling settle
                    setTimeout(function() {
                        constrainScrollPosition();
                        snapToNearestSlide();
                    }, 150);
                });
                
                // Also listen for mouse leaving the container while dragging
                $gliderContainer.off('mouseleave.sgBounds').on('mouseleave.sgBounds', function(e) {
                    // Check if mouse button was pressed (dragging)
                    if (e.buttons === 1 || e.which === 1) {
                        setTimeout(function() {
                            constrainScrollPosition();
                            snapToNearestSlide();
                        }, 150);
                    }
                });
                
                // Listen for Glider's animated event to ensure proper positioning after animations
                $gliderContainer.off('glider-animated.sgBounds').on('glider-animated.sgBounds', function() {
                    setTimeout(constrainScrollPosition, 50);
                });
                
                // Initial constraint check
                setTimeout(constrainScrollPosition, 100);
                
                console.log('Judge.me carousel drag bounds applied (local)');
            });
        }

        // Apply settings after initial setup
        setTimeout(function() {
            applyJudgeMeCarouselSettings();
        }, 500);

        // Apply settings after initial setup
        setTimeout(function() {
            applyJudgeMeCarouselSettings();
        }, 1500);

        // Listen for Judge.me carousel render event to reapply settings
        $(document).on('jdgm.doneRenderCarousel', function() {
            // Remove the processed class to allow re-application
            $('.jdgm-row-carousel').removeClass('sg-drag-bounds-applied');
            setTimeout(function() {
                applyJudgeMeCarouselSettings();
            }, 100);
        });

        // You can add more custom functionality here
        // Example: Custom styling, analytics tracking, image lazy loading, etc.

    }, false);

    // Fallback: Also try processing on window load in case jdgm.doneSetup fires before our listener is ready
    window.addEventListener('load', function() {
        setTimeout(function() {
            // Only run if not already processed correctly (check for cloned images as direct children)
            const $reviews = $('.jdgm-rev');
            const needsProcessing = $reviews.length > 0 && $reviews.filter(function() {
                return $(this).children('.cloned-review-image').length === 0;
            }).length > 0;
            
            if (needsProcessing) {
                console.log('Judge.me fallback processing on window.load');
                
                // Use the same improved logic as main handler
                $reviews.each(function() {
                    const $review = $(this);
                    const $media = $review.find('.jdgm-rev__media');
                    const $header = $review.find('.jdgm-rev__header');
                    
                    // Hide the media container with inline style
                    if ($media.length > 0 && !$media.hasClass('sg-processed')) {
                        $media.attr('style', 'display: none !important');
                        $media.addClass('sg-processed');
                    }
                    
                    // Check if cloned image already exists as DIRECT child
                    const $existingClone = $review.children('.cloned-review-image');
                    if ($existingClone.length > 0) {
                        return;
                    }
                    
                    // Remove any misplaced clones
                    $review.find('.jdgm-rev__media .cloned-review-image').remove();
                    
                    // Find the first pic link in media container
                    const $firstPicLink = $media.find('a.jdgm-rev__pic-link').first();
                    
                    if ($firstPicLink.length > 0 && $header.length > 0) {
                        const $clonedPicLink = $firstPicLink.clone();
                        $clonedPicLink.addClass('cloned-review-image');
                        $clonedPicLink.removeClass('jdgm--loading');
                        $clonedPicLink.find('img').each(function() {
                            const $img = $(this);
                            const currentSrc = $img.attr('src');
                            const currentDataSrc = $img.attr('data-src');
                            
                            // Determine the best source URL (prefer data-src for lazy loaded images)
                            let imageUrl = currentDataSrc || currentSrc;
                            
                            if (imageUrl) {
                                // Update to higher resolution
                                imageUrl = imageUrl.replace('w=160', 'w=600');
                                
                                // Always set both src and data-src to ensure image loads
                                $img.attr('src', imageUrl);
                                $img.attr('data-src', imageUrl);
                                
                                // Remove lazy loading class if present
                                $img.removeClass('lazyload lazy');
                            }
                        });
                        $header.before($clonedPicLink);
                    }
                });
                
                const $summary = $('#judgeme_product_reviews .jdgm-rev-widg__summary');
                if ($summary.length > 0) {
                    const summaryText = $summary.text().trim();
                    const ratingMatch = summaryText.match(/^(\d+\.?\d*)/);
                    if (ratingMatch) {
                        const rating = ratingMatch[1];
                        const $summaryInner = $summary.closest('.jdgm-rev-widg').find('.jdgm-rev-widg__summary-inner');
                        if ($summaryInner.length > 0 && !$summaryInner.find('.rating-value').length) {
                            $summaryInner.prepend(`<span class="rating-value">${rating}</span>`);
                        }
                    }
                }
                
                // Fix carousel widths in fallback path
                setTimeout(function() {
                    fixJudgeMeCarouselWidths();
                }, 500);
            }
        }, 1500);
        
        // Also check carousel widths on window load regardless
        setTimeout(function() {
            fixJudgeMeCarouselWidths();
        }, 2000);
        
        setTimeout(function() {
            fixJudgeMeCarouselWidths();
        }, 3500);
    });
    
    // Global function to fix carousel widths and drag bounds - can be called from both paths
    function fixJudgeMeCarouselWidths() {
        const $carousel = $('.jdgm-row-carousel');
        
        if ($carousel.length === 0) {
            return;
        }
        
        const $track = $carousel.find('.jdgm-glider-track');
        const $slides = $carousel.find('.jdgm-glider-slide');
        
        if ($track.length === 0 || $slides.length === 0) {
            return;
        }
        
        const trackWidth = parseInt($track.css('width')) || 0;
        const slideWidth = parseInt($slides.first().css('width')) || 0;
        const hasNaN = $slides.first().attr('class') && $slides.first().attr('class').indexOf('NaN') !== -1;
        const isBroken = (trackWidth === 0 || slideWidth === 0 || hasNaN);
        
        if (isBroken) {
            console.log('Judge.me carousel widths broken - fixing (track:' + trackWidth + ', slide:' + slideWidth + ')');
            
            // Trigger resize events to force Glider recalculation
            $(window).trigger('resize');
            window.dispatchEvent(new Event('resize'));
            
            // Try direct Glider refresh
            const gliderEl = $carousel.find('.jdgm-glider')[0];
            if (gliderEl && gliderEl._glider) {
                gliderEl._glider.refresh(true);
                console.log('Judge.me Glider refreshed');
            }
        }
        
        // Apply drag bounds constraints to prevent over-scrolling
        applyJudgeMeCarouselDragBounds();
    }
    
    // Function to constrain carousel drag bounds and prevent over-scrolling
    function applyJudgeMeCarouselDragBounds() {
        const $carousel = $('.jdgm-row-carousel');
        
        if ($carousel.length === 0) {
            return;
        }
        
        $carousel.each(function() {
            const $thisCarousel = $(this);
            const $gliderContainer = $thisCarousel.find('.jdgm-glider');
            const gliderEl = $gliderContainer[0];
            
            // Skip if already processed
            if ($thisCarousel.hasClass('sg-drag-bounds-applied')) {
                return;
            }
            
            $thisCarousel.addClass('sg-drag-bounds-applied');
            
            // Function to check and correct scroll position
            function constrainScrollPosition() {
                if (!gliderEl || !gliderEl._glider) {
                    return;
                }
                
                const glider = gliderEl._glider;
                const $track = $(gliderEl).find('.jdgm-glider-track');
                const $slides = $(gliderEl).find('.jdgm-glider-slide');
                
                if ($track.length === 0 || $slides.length === 0) {
                    return;
                }
                
                const containerWidth = $(gliderEl).width();
                const trackWidth = $track[0].scrollWidth || parseInt($track.css('width')) || 0;
                const slideCount = $slides.length;
                
                if (containerWidth <= 0 || trackWidth <= 0 || slideCount <= 0) {
                    return;
                }
                
                // Calculate maximum scroll position (track width minus container width)
                const maxScroll = Math.max(0, trackWidth - containerWidth);
                const currentScroll = gliderEl.scrollLeft || 0;
                
                // Constrain scroll position within bounds
                if (currentScroll < 0) {
                    gliderEl.scrollLeft = 0;
                    console.log('Judge.me carousel: corrected over-scroll to left');
                } else if (currentScroll > maxScroll) {
                    gliderEl.scrollLeft = maxScroll;
                    console.log('Judge.me carousel: corrected over-scroll to right');
                }
            }
            
            // Function to snap to nearest slide after drag ends
            function snapToNearestSlide() {
                if (!gliderEl || !gliderEl._glider) {
                    return;
                }
                
                const glider = gliderEl._glider;
                const currentScroll = gliderEl.scrollLeft || 0;
                const $slides = $(gliderEl).find('.jdgm-glider-slide');
                
                if ($slides.length === 0) {
                    return;
                }
                
                const slideWidth = $slides.first().outerWidth(true) || 0;
                
                if (slideWidth <= 0) {
                    return;
                }
                
                // Calculate nearest slide index
                const nearestSlideIndex = Math.round(currentScroll / slideWidth);
                const maxSlideIndex = Math.max(0, $slides.length - Math.floor($(gliderEl).width() / slideWidth));
                const constrainedIndex = Math.max(0, Math.min(nearestSlideIndex, maxSlideIndex));
                
                // Scroll to the nearest valid slide
                if (glider.scrollItem) {
                    glider.scrollItem(constrainedIndex, false);
                }
            }
            
            // Listen for scroll events to constrain position
            $gliderContainer.off('scroll.sgBounds').on('scroll.sgBounds', function() {
                // Use requestAnimationFrame for smooth constraint checking
                if (window.sgCarouselScrollRAF) {
                    cancelAnimationFrame(window.sgCarouselScrollRAF);
                }
                window.sgCarouselScrollRAF = requestAnimationFrame(constrainScrollPosition);
            });
            
            // Listen for drag/touch end to snap to valid position
            $gliderContainer.off('mouseup.sgBounds touchend.sgBounds').on('mouseup.sgBounds touchend.sgBounds', function() {
                // Small delay to let the momentum scrolling settle
                setTimeout(function() {
                    constrainScrollPosition();
                    snapToNearestSlide();
                }, 150);
            });
            
            // Also listen for mouse leaving the container while dragging
            $gliderContainer.off('mouseleave.sgBounds').on('mouseleave.sgBounds', function(e) {
                // Check if mouse button was pressed (dragging)
                if (e.buttons === 1 || e.which === 1) {
                    setTimeout(function() {
                        constrainScrollPosition();
                        snapToNearestSlide();
                    }, 150);
                }
            });
            
            // Listen for Glider's animated event to ensure proper positioning after animations
            $gliderContainer.off('glider-animated.sgBounds').on('glider-animated.sgBounds', function() {
                setTimeout(constrainScrollPosition, 50);
            });
            
            // Initial constraint check
            setTimeout(constrainScrollPosition, 100);
            
            console.log('Judge.me carousel drag bounds applied');
        });
    }

    // Google Ads code moved to sg-functions-product-google-ads.js
    /*
    // APPROACH 1: Liquid-based (COMMENTED OUT - Liquid code is also commented out)
    // The slider HTML is only rendered when Liquid detects utm_source=google via querystring snippet.
    // Swiper just needs to initialize the already-visible element.
    function initGoogleAdsSwiper() {
        var swiperEl = document.querySelector('.fdp-google-ads-swiper');
        if (swiperEl && typeof Swiper !== 'undefined' && !swiperEl.swiper) {
            new Swiper(swiperEl, {
                slidesPerView: 'auto',
                speed: 600,
                loop: true,
                spaceBetween: 0,
                grabCursor: true,
                navigation: {
                    nextEl: swiperEl.querySelector('.swiper-button-next'),
                    prevEl: swiperEl.querySelector('.swiper-button-prev'),
                }
            });
            console.log('[sg-product] Google Ads Swiper initialized (Liquid approach)');
        }
    }

    // Try initializing immediately, after short delay, and on window load
    initGoogleAdsSwiper();
    setTimeout(initGoogleAdsSwiper, 300);
    window.addEventListener('load', initGoogleAdsSwiper);
    */


    console.log('Judge.me event listener added');
    
    // Additional fallback: Use MutationObserver to detect when Judge.me reviews are added
    if (typeof MutationObserver !== 'undefined') {
        var jdgmObserver = new MutationObserver(function(mutations) {
            var hasNewReviews = false;
            mutations.forEach(function(mutation) {
                if (mutation.addedNodes.length) {
                    mutation.addedNodes.forEach(function(node) {
                        if (node.nodeType === 1) {
                            if (node.classList && (node.classList.contains('jdgm-rev') || node.classList.contains('jdgm-rev-widg'))) {
                                hasNewReviews = true;
                            }
                            if (node.querySelector && node.querySelector('.jdgm-rev')) {
                                hasNewReviews = true;
                            }
                        }
                    });
                }
            });
            
            if (hasNewReviews) {
                clearTimeout(window.jdgmObserverTimer);
                window.jdgmObserverTimer = setTimeout(function() {
                    console.log('Judge.me MutationObserver detected reviews - processing');
                    processJudgeMeReviewsGlobal();
                }, 300);
            }
        });
        
        // Start observing document body for Judge.me content
        if (document.body) {
            jdgmObserver.observe(document.body, { childList: true, subtree: true });
        } else {
            document.addEventListener('DOMContentLoaded', function() {
                jdgmObserver.observe(document.body, { childList: true, subtree: true });
            });
        }
    }
    
    // Interval-based fallback for Firefox - check periodically for unprocessed reviews
    var intervalCheckCount = 0;
    var intervalMaxChecks = 20; // Check for 10 seconds max
    var jdgmIntervalCheck = setInterval(function() {
        intervalCheckCount++;
        
        // Check if there are unprocessed reviews
        var $unprocessedReviews = $('.jdgm-rev').filter(function() {
            return !$(this).find('.jdgm-rev__media.sg-processed').length && 
                   $(this).find('.jdgm-rev__media').length > 0;
        });
        
        if ($unprocessedReviews.length > 0) {
            console.log('Judge.me interval check found unprocessed reviews - processing');
            processJudgeMeReviewsGlobal();
        }
        
        // Stop checking after max attempts or if all are processed
        if (intervalCheckCount >= intervalMaxChecks || $unprocessedReviews.length === 0) {
            clearInterval(jdgmIntervalCheck);
        }
    }, 500);
    
    // Global processing function that can be called from multiple paths
    function processJudgeMeReviewsGlobal() {
        $('.jdgm-rev').each(function() {
            var $review = $(this);
            var $media = $review.find('.jdgm-rev__media');
            var $header = $review.find('.jdgm-rev__header');
            
            // Hide the media container with inline style
            if ($media.length > 0 && !$media.hasClass('sg-processed')) {
                $media.attr('style', 'display: none !important');
                $media.addClass('sg-processed');
            }
            
            // Check if cloned image already exists as DIRECT child
            var $existingClone = $review.children('.cloned-review-image');
            if ($existingClone.length > 0) {
                return;
            }
            
            // Remove any misplaced clones
            $review.find('.jdgm-rev__media .cloned-review-image').remove();
            
            // Find the first pic link in media container
            var $firstPicLink = $media.find('a.jdgm-rev__pic-link').first();
            
            if ($firstPicLink.length > 0 && $header.length > 0) {
                var $clonedPicLink = $firstPicLink.clone();
                $clonedPicLink.addClass('cloned-review-image');
                $clonedPicLink.removeClass('jdgm--loading');
                $clonedPicLink.find('img').each(function() {
                    var $img = $(this);
                    var currentSrc = $img.attr('src');
                    var currentDataSrc = $img.attr('data-src');
                    
                    // Determine the best source URL (prefer data-src for lazy loaded images)
                    var imageUrl = currentDataSrc || currentSrc;
                    
                    if (imageUrl) {
                        // Update to higher resolution
                        imageUrl = imageUrl.replace('w=160', 'w=600');
                        
                        // Always set both src and data-src to ensure image loads
                        $img.attr('src', imageUrl);
                        $img.attr('data-src', imageUrl);
                        
                        // Remove lazy loading class if present
                        $img.removeClass('lazyload lazy');
                    }
                });
                $header.before($clonedPicLink);
            }
        });
        
        // Also add rating value if not present
        var $summary = $('#judgeme_product_reviews .jdgm-rev-widg__summary');
        if ($summary.length > 0) {
            var summaryText = $summary.text().trim();
            var ratingMatch = summaryText.match(/^(\d+\.?\d*)/);
            if (ratingMatch) {
                var rating = ratingMatch[1];
                var $summaryInner = $summary.closest('.jdgm-rev-widg').find('.jdgm-rev-widg__summary-inner');
                if ($summaryInner.length > 0 && !$summaryInner.find('.rating-value').length) {
                    $summaryInner.prepend('<span class="rating-value">' + rating + '</span>');
                }
            }
        }
        
        // Also apply carousel drag bounds after processing reviews
        setTimeout(function() {
            fixJudgeMeCarouselWidths();
        }, 300);
    }
//}
